<template>
  <div class="form-wrapper">
    <h2>Add Factory</h2>
    <form @submit.prevent="submitForm">
      <div class="form-group">
        <label>Name</label>
        <input v-model="factory.name" type="text" placeholder="Factory Name" required />
      </div>
      <div class="form-group">
        <label>Location</label>
        <input v-model="factory.location" type="text" placeholder="Location" />
      </div>
      <div class="form-group">
        <label>Status</label>
        <select v-model="factory.status">
          <option>Active</option>
          <option>Inactive</option>
        </select>
      </div>
      <button class="btn btn-gradient" type="submit">
        <span v-if="loading">Saving...</span>
        <span v-else>Save Factory</span>
      </button>
    </form>
  </div>
</template>

<script>
export default {
  name: 'AddFactoryComponent',
  data() {
    return { factory: { name: '', location: '', status: 'Active' }, loading: false };
  },
  methods: {
    submitForm() {
      this.loading = true;
      this.$store.dispatch('factories/addFactory', this.factory)
        .then(() => this.$router.push({ name: 'Factories' }))
        .finally(() => this.loading = false);
    }
  }
};
</script>
